import { getBreCode, isBreUsage, isBreHandlerEntry, navigateToElement, breOrigins } from './bre';

/**
 * Cross-navigation for Business Rule Exceptions.
 *
 * The Signavio export links a process exception to its description only by name
 * ("BRE3"). The converter exposes that as custom:breCode on both the throwing
 * escalation event (process side) and the StartEscalationEvent (handler side).
 *
 * Forward: clicking a throwing "BREn" event jumps to the matching handler entry
 * in the "Business Rule Exceptions" sub-process and highlights it.
 * Back: the exact origin is remembered, and a "↩ Zurück zum Prozess" button is
 * shown on the handler entry so the user returns to precisely where they came
 * from (a BRE can be used from many places).
 */
export default function BreNavigationProvider(eventBus, canvas, elementRegistry, overlays) {
  const backOverlays = {};

  function findHandlerEntry(code) {
    let target = null;
    elementRegistry.forEach((el) => {
      if (target) return;
      if (isBreHandlerEntry(el) && getBreCode(el) === code) target = el;
    });
    return target;
  }

  function removeBackOverlay(code) {
    if (backOverlays[code]) {
      try { overlays.remove(backOverlays[code]); } catch { /* already gone */ }
      delete backOverlays[code];
    }
  }

  function showBackOverlay(handlerEntry, code, originId) {
    removeBackOverlay(code);
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'bre-back-btn';
    button.title = 'Zurück zum auslösenden Prozess';
    button.textContent = '↩ Zurück zum Prozess';
    button.addEventListener('click', (ev) => {
      ev.stopPropagation();
      const origin = elementRegistry.get(originId);
      if (origin) navigateToElement(canvas, origin);
    });
    try {
      backOverlays[code] = overlays.add(handlerEntry, 'bre-back', {
        position: { top: -28, left: 0 },
        html: button,
        show: { minZoom: 0.2 },
      });
    } catch (err) {
      console.warn('[BRE] could not add back overlay', err);
    }
  }

  eventBus.on('element.click', (event) => {
    const element = event.element;
    if (!isBreUsage(element)) return;

    const code = getBreCode(element);
    const target = code && findHandlerEntry(code);
    if (!target) return;

    breOrigins.set(code, element.id);
    navigateToElement(canvas, target);
    showBackOverlay(target, code, element.id);
  });

  // Reset origins/overlays when a new diagram is loaded.
  eventBus.on('import.done', () => {
    Object.keys(backOverlays).forEach(removeBackOverlay);
    breOrigins.clear();
  });
}

BreNavigationProvider.$inject = ['eventBus', 'canvas', 'elementRegistry', 'overlays'];
